export interface IHeaderRouteInfo {
  label: string
  icon: string
  path: string
  exact?: boolean
  hidden?: boolean
}
